__turbopack_context__.v({
  "body": "ProductTakeoverTile-module-scss-module__b9KZRq__body",
  "content": "ProductTakeoverTile-module-scss-module__b9KZRq__content",
  "cta": "ProductTakeoverTile-module-scss-module__b9KZRq__cta",
  "fullBleed": "ProductTakeoverTile-module-scss-module__b9KZRq__fullBleed",
  "headline": "ProductTakeoverTile-module-scss-module__b9KZRq__headline",
  "image": "ProductTakeoverTile-module-scss-module__b9KZRq__image",
  "imageWrapper": "ProductTakeoverTile-module-scss-module__b9KZRq__imageWrapper",
  "link": "ProductTakeoverTile-module-scss-module__b9KZRq__link",
  "promoImage": "ProductTakeoverTile-module-scss-module__b9KZRq__promoImage",
  "scrim": "ProductTakeoverTile-module-scss-module__b9KZRq__scrim",
  "text": "ProductTakeoverTile-module-scss-module__b9KZRq__text",
  "tile": "ProductTakeoverTile-module-scss-module__b9KZRq__tile",
  "wide": "ProductTakeoverTile-module-scss-module__b9KZRq__wide",
});
